import React from 'react';
import { DatePicker, DayOfWeek, IDatePickerStrings } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { pad } from '../../utils';

export interface ICustomDatePicker {
	selectedDate: Date | undefined;
	onChange: (date: Date) => void;
}

export const CustomDatePicker = (props: ICustomDatePicker) => {
	const { t } = useTranslation();

	const months = [
		t('datepicker.month.1'),
		t('datepicker.month.2'),
		t('datepicker.month.3'),
		t('datepicker.month.4'),
		t('datepicker.month.5'),
		t('datepicker.month.6'),
		t('datepicker.month.7'),
		t('datepicker.month.8'),
		t('datepicker.month.9'),
		t('datepicker.month.10'),
		t('datepicker.month.11'),
		t('datepicker.month.12'),
	];

	const days = [
		t('datepicker.days.1'),
		t('datepicker.days.2'),
		t('datepicker.days.3'),
		t('datepicker.days.4'),
		t('datepicker.days.5'),
		t('datepicker.days.6'),
		t('datepicker.days.7'),
	];

	const DayPickerStrings: IDatePickerStrings = {
		months: months,
		shortMonths: months.map((m) => m.substring(0, 3)),
		days: days,
		shortDays: days.map((d) => d.substring(0, 1)),
		goToToday: t('datepicker.today'),
		prevMonthAriaLabel: t('datepicker.preMonth'),
		nextMonthAriaLabel: t('datepicker.nextMonth'),
		prevYearAriaLabel: t('datepicker.preYear'),
		nextYearAriaLabel: t('datepicker.nextYear'),
		closeButtonAriaLabel: t('datepicker.close'),
	};

	const onFormatDate = (date?: Date | undefined): string => {
		if (!date) return '';
		return pad(date.getDate(), 2) + '.' + pad(date.getMonth() + 1, 2) + '.' + pad(date.getFullYear(), 2);
	};

	const onSelectDate = (date: Date | null | undefined): void => {
		if (!date) return;
		props.onChange(date);
	};

	return (
		<DatePicker
			firstDayOfWeek={DayOfWeek.Monday}
			strings={DayPickerStrings}
			showWeekNumbers={true}
			firstWeekOfYear={1}
			showMonthPickerAsOverlay={true}
			formatDate={onFormatDate}
			placeholder={t('datepicker.placeholder')}
			ariaLabel={t('datepicker.arial')}
			value={props.selectedDate}
			onSelectDate={onSelectDate}
		/>
	);
};
